export const TRANSPORT_STATUSES = [
  { key: 'assigned', label: 'Assigned', color: 'info' },
  { key: 'picked_up', label: 'Picked Up', color: 'primary' },
  { key: 'delivered', label: 'Delivered', color: 'secondary' },
  { key: 'pending_approval', label: 'Pending Approval', color: 'warning' },
  { key: 'complete', label: 'Complete', color: 'success' },
  { key: 'cancelled', label: 'Cancelled', color: 'default' },
];

export const TRANSPORT_STATUS_ORDER = [
  'assigned',
  'picked_up',
  'delivered',
  'pending_approval',
  'complete',
];

export const TRANSPORT_JOB_TYPES = [
  { key: 'delivery', label: 'Delivery' },
  { key: 'pickup', label: 'Pickup' },
  { key: 'pickup_delivery', label: 'Pickup & Delivery' },
  { key: 'other', label: 'Other' },
];

export function transportStatusMeta(status) {
  return TRANSPORT_STATUSES.find((s) => s.key === status) || TRANSPORT_STATUSES[0];
}

export function transportJobTypeLabel(type) {
  return TRANSPORT_JOB_TYPES.find((t) => t.key === type)?.label || type || '—';
}

export function formatTimeInput(value) {
  if (value == null || value === '') return '';
  const s = String(value);
  const m = s.match(/(\d{2}):(\d{2})/);
  return m ? `${m[1]}:${m[2]}` : '';
}

export function formatDateInput(value) {
  if (value == null || value === '') return '';
  const s = String(value);
  const ymd = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (ymd) return ymd[1];
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function formatAddressLines(parts) {
  return parts.filter((p) => p != null && String(p).trim() !== '').join(', ');
}

export function driverDisplayName(job) {
  if (!job) return '';
  if (job.driver_name) return job.driver_name;
  const emp = [job.driver_employee_first_name, job.driver_employee_last_name].filter(Boolean).join(' ').trim();
  if (emp) return emp;
  return job.vendor_name || '';
}
